import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const INSPECTION_SIDE_PADDING = '5%';
export const INSPECTION_COLUMN_GAP = '10%';

export const inspectionSectionPaddingSx: SxProps<Theme> = {
  paddingLeft: INSPECTION_SIDE_PADDING,
  paddingRight: INSPECTION_SIDE_PADDING,
};

export const inspectionGridSx: SxProps<Theme> = {
  ...inspectionSectionPaddingSx,
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
  },
  columnGap: INSPECTION_COLUMN_GAP,
  rowGap: 2,
  width: '100%',
  boxSizing: 'border-box',
};

export const inspectionGridFullWidthItemSx: SxProps<Theme> = {
  gridColumn: {
    xs: '1 / -1',
    sm: '1 / -1',
  },
};

export const inspectionSubheaderBaseSx: SxProps<Theme> = {
  fontSize: '1.125rem',
  ...inspectionSectionPaddingSx,
};

export const inspectionProtocolWrapperSx: SxProps<Theme> = {
  ...inspectionSectionPaddingSx,
  mt: 0,
};

export const inspectionProtocolWrapperWithFooterSpacerSx: SxProps<Theme> = {
  paddingLeft: INSPECTION_SIDE_PADDING,
  paddingRight: INSPECTION_SIDE_PADDING,
  mt: 0,
  mb: '120px',
};

/** Shared full-page form shell tokens (inspection, template wizard, user wizard). */
export const inspectionFormPageHeaderRowSx: SxProps<Theme> = {
  ...inspectionSectionPaddingSx,
  mt: 4,
  mb: 4,
  gap: 1,
};

export const inspectionFormPageTitleSx: SxProps<Theme> = {
  ...inspectionSubheaderBaseSx,
  paddingLeft: 0,
  paddingRight: 0,
};

export const inspectionFormSectionDescriptionSx: SxProps<Theme> = {
  ...inspectionSectionPaddingSx,
  color: Color.iconGray,
  fontSize: '0.875rem',
  mb: 2,
};

export const inspectionFormSectionDividerSx: SxProps<Theme> = {
  my: 4,
};

export const inspectionFormFooterSpacerSx: SxProps<Theme> = {
  mb: '120px',
};
